import UpdateEggDocument from './UpdateEggDocument'

export default UpdateEggDocument
